import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment  } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  mainURL = 'api/payment/';
  constructor(private http: HttpClient, private router: Router) { }

  sendPaymentRequest(payment: any) {
    let userId = JSON.parse(localStorage.getItem('userInfo')!).userId;
    return this.http.post(environment.apiUrl + this.mainURL + userId + '/sendPaymentRequest', payment, { responseType: 'text' });
  }

  getProduct(productKey: string) {
    return this.http.get('assets/products.json').toPromise().then((products: any) => {
      return products.find((product: any) => product.name === productKey);
    });
  }

  

  getProducts() {
    return this.http.get(environment.apiUrl + this.mainURL + 'getProducts');
  }

  getPayments() {
    return this.http.get(environment.apiUrl + this.mainURL + 'getPayments');
  }

  setProducts() {
    this.http.get("assets/products.json").subscribe((res: any) => {
      return this.http.post(environment.apiUrl + this.mainURL + 'setProducts', res).subscribe((res) => {
        console.log(res);
      });
    })
  }

  checkIsProductPurchased(productName: string): Promise<boolean> {
    let userId = JSON.parse(localStorage.getItem('userInfo')!).userId;
    return new Promise((resolve, reject) => {
      this.http.post(environment.apiUrl + this.mainURL + userId + '/checkProductStatus', productName).subscribe((isPurchased) => {
        if (isPurchased) {
          resolve(true);
        } else {
          resolve(false);
        }
      }, (error) => {
        reject(error);
      });
    });
  }
}
